import { render, staticRenderFns } from "./environment.vue?vue&type=template&id=518d7d94&scoped=true&"
import script from "./environment.vue?vue&type=script&lang=js&"
export * from "./environment.vue?vue&type=script&lang=js&"
import style0 from "./environment.vue?vue&type=style&index=0&id=518d7d94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d7d94",
  null
  
)

export default component.exports